// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navbar_navigation__BFTGz","menuContainer":"Navbar_menuContainer__1VQhI"};